module.exports = __webpack_public_path__ + "static/media/6.447c71d3.jpg";